import { FiCompass, FiUsers, FiTrendingUp } from 'react-icons/fi'
import students from '@/assets/images/group-3137670_1280.jpg'
import women from '@/assets/images/IBON-World-Launch-37.jpeg'
import culture from '@/assets/images/IBON-World-Launch-27.jpeg'
import advocacy from '@/assets/images/IBON-World-Launch-14.jpeg'
import type { ApproachStep, Programme } from '@/types/programmes'

export const approachSteps: ApproachStep[] = [
  {
    no: '01',
    title: 'Discover & Connect',
    description:
      'We identify talented young people, entrepreneurs, and institutions, then connect them to opportunities, mentors, and peers across Africa and the Caribbean.',
    Icon: FiCompass,
  },
  {
    no: '02',
    title: 'Equip & Empower',
    description:
      'Through training, mentorship, and hands-on support, we build the practical skills, leadership confidence, and networks needed to turn ideas into action.',
    Icon: FiUsers,
  },
  {
    no: '03',
    title: 'Grow & Sustain',
    description:
      'We help ventures and initiatives scale through access to funding, markets, and ongoing collaboration, creating lasting, inclusive socio-economic growth.',
    Icon: FiTrendingUp,
  },
]

export const programmes: Programme[] = [
  {
    no: '01',
    pillar: 'Business',
    title: 'Africa Caribbean Young Entrepreneurs and Innovation Hub (AfCa-YEIH)',
    description:
      'AfCa-YEIH connects and supports young entrepreneurs from Africa and the Caribbean, providing mentorship, innovation challenges, and cross-regional networks to grow their ventures and drive sustainable economic development.',
    highlights: ['Youth entrepreneurship', 'Cross-regional networks', 'Innovation challenges'],
    image: students,
  },
  {
    no: '02',
    pillar: 'Education & Leadership',
    title: 'Technical University Women in Entrepreneurship (TUWE)',
    description:
      'TUWE equips aspiring women entrepreneurs with mentorship, leadership development, and enterprise support to transform ideas into sustainable ventures and pursue economic independence.',
    highlights: ['Women-led ventures', 'Mentorship & leadership', 'STEM & AI focus'],
    image: women,
  },
  {
    no: '03',
    pillar: 'Education & Leadership',
    title: 'Africa Caribbean Student-Preneur & Innovation Hub (AfCaSPIH) Nexus',
    description:
      'A platform that brings together students and entrepreneurs from Africa and the Caribbean to exchange ideas, develop innovative solutions, and build cross-regional networks that inspire enterprise and collaboration.',
    highlights: ['Student entrepreneurship', 'Cross-regional collaboration', 'Innovation support'],
    image: advocacy,
  },
  {
    no: '04',
    pillar: 'Culture',
    title: 'Africa Caribbean Culture Festival (AfCa-CF)',
    description:
      'AfCa-CF is an annual celebration of African and Caribbean cultural heritage through art, music, dance, fashion, and food, bringing communities together to preserve identity and inspire creative entrepreneurship.',
    highlights: ['Art, music & fashion', 'Cultural exchange', 'Annual festival'],
    image: culture,
  },
]
